import {ShopContainer} from "../ShopContainer";
import React from "react";
import {MiscSwitcher} from "../../quote/misc/MiscSwitcher";
import {ProjectPageTitle} from "../ProjectPageTitle";
import {MiscTable} from "./MiscTable";
import {tabGroup} from "../../../logistics/purchasing/PartsToSource";
import {Tab, Tabs} from "@mui/material";
import {useTabQueryParam} from "../../../../misc/userpref/useTabQueryParam";
import {TabWrapper} from "../TabWrapper";
import {MiscPricing} from "../pricing/MiscPricing";


export function Misc() {
    const [tab, setTab, dt] = useTabQueryParam({page: "shopdrawing.misc", urlKey: "m", fallback: "overview", allowed: ["overview", "pricing"]});

    return (
        <ShopContainer name={<MiscSwitcher />}>
            <ProjectPageTitle title="Misc" />
            <TabWrapper>
                <Tabs className={tabGroup} value={tab} onChange={(e, value) => setTab(value)}>
                    <Tab label="Overview" value="overview" {...dt.tabProps("overview")} />
                    <Tab label="Pricing" value="pricing" {...dt.tabProps("pricing")} />
                </Tabs>
                {dt.controls}
            </TabWrapper>
            {tab === "overview" && <MiscTable />}
            {tab === "pricing" && <MiscPricing />}
        </ShopContainer>
    )
}